"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
SearchController.$inject = ['$scope', '$location', '_search', '_product'];
function SearchController($scope, $location, _search, _product) {
    $scope.products = [];
    $scope.loading = false;
    $scope.$watch(function () { return $location.search().q; }, function (searchText) {
        search(searchText);
    });
    var search = function (searchText) {
        if (searchText && searchText.length) {
            $scope.loading = true;
            _search.get(searchText).then(function (products) {
                $scope.loading = false;
                setProducts(products);
            }, function (error) {
                $scope.loading = false;
                console.log('error', error);
            });
        }
        else {
            setProducts([]);
        }
    };
    var setProducts = function (products) {
        $scope.products = products;
        _product.setList($scope.products);
    };
    $scope.openModal = function (product, index) {
        $location.search('productView', product._id);
        _product.viewProduct(product, index, null);
    };
}
exports.SearchController = SearchController;



//////////////////
// WEBPACK FOOTER
// ./scripts/apps/search/controllers/SearchController.js
// module id = 468
// module chunks = 0